import { defineComponent as n, openBlock as o, createBlock as r, unref as p, mergeProps as d, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconBadge",
  __name: "IconBadge",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (c, l) => (o(), r(p(u), d(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...l[0] || (l[0] = [
        e("path", { d: "M12.269 6.401a.3.3 0 0 0-.538 0l-.837 1.695a.3.3 0 0 1-.226.165l-1.87.271A.3.3 0 0 0 8.63 9.044l1.354 1.32a.3.3 0 0 1 .086.265l-.32 1.864a.3.3 0 0 0 .436.316l1.673-.88a.3.3 0 0 1 .28 0l1.673.88a.3.3 0 0 0 .435-.316l-.32-1.864a.3.3 0 0 1 .087-.265l1.354-1.32a.3.3 0 0 0-.166-.512l-1.871-.271a.3.3 0 0 1-.226-.165l-.837-1.695" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M5.25 9.856a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0M12 4.606a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "m7.813 15.15-1.52 4.179a.3.3 0 0 0 .437.358l1.684-1.025a.3.3 0 0 1 .44.16l.631 1.868a.3.3 0 0 0 .566.007l1.495-4.106a6.7 6.7 0 0 1-3.733-1.44m4.609 1.442a6.7 6.7 0 0 0 3.74-1.422l1.513 4.158a.3.3 0 0 1-.438.358l-1.684-1.025a.3.3 0 0 0-.44.16l-.63 1.868a.3.3 0 0 1-.567.007l-1.494-4.104" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
